import chalk from 'chalk'
const logFn = console.log

export const log = (title, ...infos) => {
  if (infos.length === 0) {
    return logFn(`${new Date().toISOString()} `, title)
  }
  return logFn(`${new Date().toISOString()} [${title}] `, ...infos)
}

export const logErr = (title, ...infos) => {
  if (infos.length === 0) {
    return logFn(chalk.red(`${new Date().toISOString()} `, title))
  }
  return logFn(chalk.red(`${new Date().toISOString()} [${title}] `, ...infos))
}

export const info = log
export const error = logErr
